module.exports = __webpack_public_path__ + "static/img/share_emoji_05.e9c478b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/share_emoji_05.png
// module id = NYV4
// module chunks = 1